<template>
  <div class="condition-reports-list tab-table p-2">
    <condition-reports-table :inventory="inventory"
                             change-permission="change_condition_report"
                             delete-permission="delete_condition_report"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ConditionReportsTable from "@/modules/condition-reports/ConditionReportsTable.vue";

  const {mapState} = createNamespacedHelpers('inventory');
  const {mapActions} = createNamespacedHelpers('conditionReports');

  export default {
    name: "InventoryConditionReports",
    components: {ConditionReportsTable},
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory,
      }),
    },
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'inventory',
        extraFilters: {inventory_uuid: this.inventory.uuid}
      });
    }
  }
</script>

<style scoped>
</style>
